import { Pipe, PipeTransform } from '@angular/core';
import { isNumber, isString, orderBy } from 'lodash';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {

  transform(array: any[] | undefined, sortBy: string, order?: string) {
    if (array == undefined) {
      return undefined;
    }

    // setting default ascending order
    let sortOrder: 'asc' | 'desc' = (order === 'desc') ? 'desc' as const : 'asc' as const;

    return orderBy<any[]>(array, [
      item => {
        let itemDetail = item[sortBy];
        if (isString(itemDetail)) {
          return itemDetail.toLowerCase()
        }
        return itemDetail;
      }
    ], [sortOrder]);
  }
}
